// extracted by mini-css-extract-plugin
export default {"status":"status-dropdown_status__aBhgO"};